module.exports = __webpack_public_path__ + "static/media/icon-waiting.3a2d9f99.png";